// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"aa30c6","checkbox__checked":"_8894b6"};